import * as angular from "angular";
import {RosterHistoryTransformer} from "./services/RosterHistoryTransformer";
import {ngCache} from "ng-cache";
import {ngLeague} from "ng-league/module";
import {component} from "./decorators/Component";
import {PlayRosterPageController} from "./components/PlayRosterPageComponent";

export let playRosterPage: angular.IModule = angular.module("playRosterPage", [
    "pascalprecht.translate",
    ngLeague.name,
    ngCache.name
]);

playRosterPage.service("RosterHistoryTransformer", RosterHistoryTransformer);

playRosterPage.config(["$translateProvider", function($translateProvider) {
    $translateProvider.translations("en", {
        "roster-page:roster-for": "Roster for",

        "roster-page:name": "Name",
        "roster-page:game-id": "Game ID",
        "roster-page:last-join": "Last join date",

        "roster-page:roster-history": "Roster History",
        "roster-page:player": "Player",
        "roster-page:join-date": "Join date",
        "roster-page:leave-date": "Leave date",
    });
}]);

playRosterPage.config(["$httpProvider", "$compileProvider", (
    $httpProvider:angular.IHttpProvider,
    $compileProvider:angular.ICompileProvider
) => {
    $httpProvider.useApplyAsync(true);
    $compileProvider.debugInfoEnabled(false);
}]);

playRosterPage.component("playRosterPage", component({
    bindings: {
        teamId: "<",
        leagueId: "<",
        gameAccountDescriptions: "<",
        dateFormatter: "&"
    },
    template: require("html-loader!./components/play-roster-page.html"),
    controllerAs: "ctrl",
    controller: PlayRosterPageController
}));
